import React from 'react';
import { NOTIFY_ME_VARIANTS } from '@yme/pdp-components/NotifyMe/constants';
import { NotifyMeBackInStockButton } from './BackInStock';
import { NotifyMeProductReleaseButton } from './ProductReleaseAnnouncement';
export function NotifyMeCurrentButton({ NotifyMeType, isRightToLeft, notifyMeLabels, variantSku, isButtonView, productCampaignIDAttribute, privacyConsentsModel, }) {
    if (NotifyMeType === NOTIFY_ME_VARIANTS.backInStock) {
        return (React.createElement(NotifyMeBackInStockButton, { isButtonView: isButtonView, variantSku: variantSku, labels: notifyMeLabels, isRightToLeft: isRightToLeft }));
    }
    if (NotifyMeType === NOTIFY_ME_VARIANTS.productReleaseAnnouncement) {
        return (React.createElement(NotifyMeProductReleaseButton, { productCampaignIDAttribute: productCampaignIDAttribute, labels: notifyMeLabels, isRightToLeft: isRightToLeft, privacyConsentsModel: privacyConsentsModel }));
    }
    return null;
}
